import React from 'react';
import BankAccounts from '../components/bankaccounts/BankAccounts';

export const BankAccountsPage: React.FC = () => {
  return <BankAccounts />;
};